import { forwardRef } from 'react';
import type { PropsWithoutRef, Ref } from 'react';
import styled from 'styled-components';

import type { BaseProps, ForwardRefForwardPropsComponent } from '../../types';
import NoValue from '../NoValue/NoValue';

export interface ParagraphDisplayProps extends BaseProps {
  /** Paragraph text */
  value?: string;
  /** Ref for the wrapping element. */
  ref?: Ref<HTMLParagraphElement>;
}

const StyledParagraphDisplay = styled.p`
  white-space: break-spaces;
`;

const ParagraphDisplay: ForwardRefForwardPropsComponent<ParagraphDisplayProps> = forwardRef(
  function ParagraphDisplay(
    { value, ...restProps }: PropsWithoutRef<ParagraphDisplayProps>,
    ref: ParagraphDisplayProps['ref']
  ) {
    return (
      <StyledParagraphDisplay ref={ref} {...restProps}>
        {value !== undefined ? value : <NoValue />}
      </StyledParagraphDisplay>
    );
  }
);

export default ParagraphDisplay;
